import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: '100%';
  display: flex;
  overflow: hidden;
  flex-direction: column;
  ${({ theme }) => css`
    gap: ${theme.padding.small};
  `}
`;

export const ImageContainer = styled.div`
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    object-fit: cover;
  }

  ${({ theme }) => css`
    border-radius: ${theme.borderRadius.biggest};
    background-color: ${theme.colors.darkGrey.main};
  `}
`;

export const ImagesListContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: scroll;
  padding-bottom: 16px;
`;
